import { Box, Typography } from '@mui/material';

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
      <Typography variant="h5" component="span" sx={{ letterSpacing: '0.12em' }}>
        PAKAITHIP
      </Typography>
      {!compact && (
        <Typography variant="caption" sx={{ color: 'text.secondary', letterSpacing: '0.08em' }}>
          ພະກາຍທິບ · ລະບົບຈັດການ
        </Typography>
      )}
    </Box>
  );
}
